import MapComponent from './MainMap.js';
import { ControlPosition, GoogleMapType } from './Map.constants';

export default {
  // Components
  Main: MapComponent,
  ControlPosition,
  GoogleMapType
};
